module.exports = __webpack_public_path__ + "img/c51b9a3.svg";